export const environment = {
  production: false,
  apiServer: "https://claimportal-api-gwc-dev-gsc8bqevdneqhccs.canadacentral-01.azurewebsites.net",
  environmentHumanReadablePhrase: "Beta",
  environmentHumanReadablePhraseClass: "bg-warning",
  ssoServer: "https://alpha.sso.globalwarranty.net",
  e2Url: "https://alpha.e2.eazeetrak.com" 
};
